var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.75C4 1.23122 5.23122 0 6.75 0H9.25C10.7688 0 12 1.23122 12 2.75V3.19269C12.572 3.24808 13.1407 3.31524 13.7057 3.39392C15.0526 3.58149 16 4.74901 16 6.07023V9.53857C16 10.6653 15.3058 11.7301 14.1705 12.0786C12.2185 12.6778 10.1462 13 8 13C5.8538 13 3.78149 12.6778 1.82951 12.0786C0.694234 11.7301 0 10.6653 0 9.53857V6.07023C0 4.74901 0.947371 3.58149 2.29435 3.39392C2.85933 3.31524 3.42796 3.24808 4 3.19269V2.75ZM10.5 2.75V3.07499C9.67296 3.02523 8.83939 3 8 3C7.16061 3 6.32704 3.02523 5.5 3.07499V2.75C5.5 2.05964 6.05964 1.5 6.75 1.5H9.25C9.94036 1.5 10.5 2.05964 10.5 2.75ZM8 9C7.44772 9 7 9.44772 7 10V10.01C7 10.5623 7.44772 11.01 8 11.01H8.01C8.56229 11.01 9.01 10.5623 9.01 10.01V10C9.01 9.44772 8.56229 9 8.01 9H8Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.0552V13.3714C1.1256 13.4243 1.25542 13.4715 1.38933 13.5126C3.48234 14.1551 5.70295 14.5 8 14.5C10.297 14.5 12.5177 14.1551 14.6107 13.5126C14.7446 13.4715 14.8744 13.4243 15 13.3714V14.0552C15 15.4024 14.0154 16.5854 12.6369 16.7406C11.1147 16.9119 9.56747 16.9999 8 16.9999C6.43253 16.9999 4.88533 16.9119 3.36311 16.7406C1.98461 16.5854 1 15.4024 1 14.0552Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.cd53a9cde1cd31348c2409a2fbe87051.svg";
export { ForwardRef as ReactComponent };